import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PortletModule } from '@gspwidget/widget-core';
import { ShellLayoutComponent } from './shell-layout.component';

@NgModule({
  declarations: [
    ShellLayoutComponent,
  ],
  imports: [
    CommonModule,
    PortletModule,
  ],
  exports: [
    ShellLayoutComponent,
  ],
  providers: [
  ]
})
export class ShellLayoutModule { }
